import React from "react";
import { type Etapa } from "interfaces/oportunidades.interface";
import { RootStateOrAny, useSelector } from "react-redux";
import { AuthState } from "store/ducks/auth/types";
import { obterNomeEtapaExibicao } from "utils/obterNomeEtapaExibicao";

import * as Styles from "./stepbystep.styles";

interface Props {
  steps: Etapa[];
  etapasPendencias?: string[];
}

const StepByStep: React.FC<Props> = ({ steps, etapasPendencias }) => {
  const { usuarioVivaz } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const generateColor = (status: number | null, codigoEtapa: string) => {
    if (etapasPendencias?.includes(codigoEtapa)) {
      return "#F43636";
    }
    switch (status) {
      case 0:
        if (codigoEtapa === "100000002") {
          return "#4CAF50";
        }
        return "#2196F3";

      case 2:
        return "#F43636";
      case 1:
        return "#4CAF50";
      default:
        return "#f0f0f0";
    }
  };

  const generateLineColor = (status: number | null) => {
    if (status === null) {
      return "#f0f0f0";
    }
    return "#4CAF50";
  };

  return (
    <Styles.Container>
      {steps.map((item: Etapa, index: number) => (
        <>
          {index > 0 && index !== steps.length ? (
            <Styles.Line color={generateLineColor(item?.codigoStatusEtapa)} />
          ) : null}
          <Styles.StepContainer>
            <Styles.StepText>
              {obterNomeEtapaExibicao(item?.nomeEtapa, usuarioVivaz)}
            </Styles.StepText>
            <Styles.Circle
              color={generateColor(item?.codigoStatusEtapa, item?.codigoEtapa)}
            />
          </Styles.StepContainer>
        </>
      ))}
    </Styles.Container>
  );
};

export default StepByStep;
